<template>
    <div id="container"></div>
</template>

<script>
export default {
    name: "map-view",
    props: {
        position: {
            type: Array,
            default: () => [114.08468799999991, 22.540092000000005], // 默认深圳市中心坐标
            validator: (value) => {
                return value.length === 2 &&
                    typeof value[0] === 'number' &&
                    typeof value[1] === 'number';
            }
        }
    },
    data() {
        return {
            map: null,
            marker: null,
            maxRetries: 3, // 最大重试次数
            retryDelay: 2000, // 重试延迟时间（毫秒）
            currentRetry: 0 // 当前重试次数
        }
    },
    watch: {
        position: {
            handler(newVal) {
                if (this.map && this.marker) {
                    // 更新地图中心点
                    this.map.setCenter(new TMap.LatLng(newVal[1], newVal[0]));
                    // 更新标记位置
                    this.marker.updateGeometries([{
                        id: 'marker',
                        styleId: 'marker',
                        position: new TMap.LatLng(newVal[1], newVal[0])
                    }]);
                }
            },
            deep: true
        }
    },
    mounted() {
        this.loadTMapScript();
    },
    beforeUnmount() {
        this.destroyMap();
    },
    methods: {
        loadTMapScript() {
            // 无论如何，先销毁之前可能存在的地图实例
            this.destroyMap();
            
            if (window.TMap) {
                this.initTMap();
                return;
            }

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=2VGBZ-D7GCL-DTZPH-MFKJD-LORT5-WFBXR';

            script.onerror = () => {
                if (this.currentRetry < this.maxRetries) {
                    this.currentRetry++;
                    console.warn(`腾讯地图加载失败，${this.currentRetry}秒后重试...`);
                    setTimeout(() => {
                        this.loadTMapScript();
                    }, this.retryDelay);
                } else {
                    console.error('腾讯地图加载失败，请检查网络连接或刷新页面重试');
                }
            };

            script.onload = () => {
                this.initTMap();
            };

            document.head.appendChild(script);
        },

        initTMap() {
            // 初始化腾讯地图，无需在此销毁，已在loadTMapScript开始时做了
            const initMap = () => {
                // 确保容器是空的
                const container = document.getElementById('container');
                if (container) {
                    container.innerHTML = '';
                }
                
                this.map = new TMap.Map('container', {
                    zoom: 11,
                    center: new TMap.LatLng(this.position[1], this.position[0]),
                });

                // 创建标记
                this.marker = new TMap.MultiMarker({
                    map: this.map,
                    styles: {
                        "marker": new TMap.MarkerStyle({
                            width: 25,
                            height: 35,
                            anchor: { x: 12.5, y: 35 },
                            src: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
                        })
                    },
                    geometries: [{
                        id: 'marker',
                        styleId: 'marker',
                        position: new TMap.LatLng(this.position[1], this.position[0])
                    }]
                });
            };

            try {
                initMap();
            } catch (error) {
                if (this.currentRetry < this.maxRetries) {
                    this.currentRetry++;
                    console.warn(`地图初始化失败，${this.currentRetry}秒后重试...`, error);
                    setTimeout(() => {
                        this.initTMap();
                    }, this.retryDelay);
                } else {
                    console.error('地图初始化失败，请刷新页面重试', error);
                }
            }
        },

        destroyMap() {
            // 销毁地图实例和相关资源
            if (this.map) {
                this.map.destroy();
                this.map = null;
            }
            if (this.marker) {
                this.marker = null;
            }
            
            // 移除容器中的内容
            const container = document.getElementById('container');
            if (container) {
                container.innerHTML = '';
            }
            
            // 重置重试计数
            this.currentRetry = 0;
        }
    },
};
</script>

<style scoped>
#container {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1; /* 保持较低的 z-index */
}
</style>

